<template>
  <div>
    <form-section :title="$t('Integrations_Settings_BasicSettings')">
      <rest-form-item
        :label="$t('Integrations_Field_Name')"
        :hint="$t('Integrations_Field_Name_Description')"
        prop="name"
      >
        <el-input
          v-model="model.name"
          :placeholder="$t('Integrations_Field_Name')"
        />
      </rest-form-item>
    </form-section>

    <form-section :title="$t('Integrations_Settings_ConnectionSettings')">
      <rest-form-item
        :label="$t('Integrations_Betsson_Field_Url')"
        prop="params.url"
        :hint="$t('Integrations_Betsson_Field_Url_Hint')"
      >
        <el-input v-model="model.params.url" placeholder="https://" />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Betsson_Field_BrandId')"
        prop="params.brand_id"
        :hint="$t('Integrations_Betsson_Field_BrandId_Hint')"
      >
        <enum-select
          v-model="model.params.brand_id"
          :options="BetssonBrandIds"
        />
      </rest-form-item>
      <rest-form-item
        :label="$t('Integrations_Betsson_Field_ApiKey')"
        prop="params.api_key"
        :hint="$t('Integrations_Betsson_Field_ApiKey_Hint')"
      >
        <el-input
          v-model="model.params.api_key"
          :placeholder="$t('Integrations_Betsson_Field_ApiKey')"
        />
      </rest-form-item>
    </form-section>
  </div>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import RestFormItem from '@/common/components/rest/RestFormItem'
import EnumSelect from '@/common/components/form/EnumSelect'
import { BetssonBrandIds } from '@/modules/integrations/types/betsson/BetssonBrandIdEnum'

export default {
  name: 'BetssonSettings',
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  components: {
    FormSection,
    RestFormItem,
    EnumSelect
  },
  data() {
    return {
      BetssonBrandIds,
      rules: {
        name: {
          required: true,
          message: this.$t('RestForm_FieldIsRequired')
        },
        params: {
          url: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          brand_id: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          },
          api_key: {
            required: true,
            message: this.$t('RestForm_FieldIsRequired')
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/integrations/types/betsson/BetssonSettings.vue